/*
 * Barre d'achat collante mobile.
 *
 * Element personnalise plutot que script inline : la section est remplacee par
 * la Section Rendering API a chaque changement de variante, et un script injecte
 * via innerHTML ne se rejoue pas. Un custom element, lui, se reconnecte tout seul.
 *
 * data-trigger      id du bouton d'ajout au panier d'origine ; la barre apparait
 *                   quand ce bouton n'est plus dans le viewport.
 * data-price-source id du conteneur de prix de la section ; son contenu est
 *                   recopie dans la barre pour rester synchrone avec la variante.
 */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        const trigger = document.getElementById(this.dataset.trigger);
        if (trigger) {
          this.triggerObserver = new IntersectionObserver(([entry]) => {
            this.classList.toggle('is-visible', !entry.isIntersecting);
          });
          this.triggerObserver.observe(trigger);
        }

        const source = document.getElementById(this.dataset.priceSource);
        const target = this.querySelector('[data-sticky-atc-price]');
        if (source && target) {
          this.priceObserver = new MutationObserver(() => {
            // On ne recopie que le montant : le bloc prix de la section contient
            // aussi des libelles masques et, en promo, l'ancien prix barre.
            const root = source.querySelector('.price') || source;
            const onSale = root.classList.contains('price--on-sale');
            const amount = root.querySelector(onSale ? '.price-item--sale' : '.price-item--regular');
            target.textContent = (amount || root).textContent.trim();
          });
          this.priceObserver.observe(source, {
            characterData: true,
            childList: true,
            subtree: true,
          });
        }
      }

      disconnectedCallback() {
        if (this.triggerObserver) this.triggerObserver.disconnect();
        if (this.priceObserver) this.priceObserver.disconnect();
      }
    }
  );
}
